import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import Panel from '../components/Panel';
import StatCard from '../components/StatCard';
import { IconLayers, IconUsers, IconPin } from '../components/icons';

const TYPE_TAG = {
  'Résidentielle': 'tag--green',
  'Mixte': 'tag--slate',
  'Transit / affaires': 'tag--blue',
  'Transit': 'tag--amber',
  'Économique': 'tag--blue',
};

export default function Profiling() {
  const { loading, data, live } = useApi(() => api.profiling());
  const zones = data?.zones || [];
  const maxEnt = Math.max(1, ...zones.map((z) => z.entropy_places || 0));
  const totalUsers = zones.reduce((a, z) => a + (z.users || 0), 0);

  return (
    <>
      <Topbar title="Profilage comportemental des zones" subtitle="Typologie via indicateurs bandicoot (Dataset 3)" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Zones profilées" value={String(zones.length)} icon={IconLayers} delay={0} />
              <StatCard label="Usagers analysés" value={new Intl.NumberFormat('fr-FR', { notation: 'compact' }).format(totalUsers)} icon={IconUsers} delay={70} />
              <StatCard label="Type dominant" value={zones[0]?.type || '—'} icon={IconPin} delay={140} />
            </div>

            <Panel icon={IconLayers} title="Profils par arrondissement" sub="entropie = diversité des lieux fréquentés" badge={`${zones.length} zones`} delay={120}>
              <table className="tbl">
                <thead>
                  <tr>
                    <th>Zone</th><th>Type</th><th>Entropie des lieux</th>
                    <th className="num">Rayon (km)</th><th className="num">% domicile</th>
                    <th className="num">Jours actifs</th><th className="num">Usagers</th>
                  </tr>
                </thead>
                <tbody>
                  {zones.map((z) => (
                    <tr key={z.zone_id}>
                      <td><b>{z.nom}</b></td>
                      <td><span className={`tag ${TYPE_TAG[z.type] || 'tag--slate'}`}>{z.type}</span></td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div className="flow__bar" style={{ flex: 1, maxWidth: 120 }}>
                            <div className="flow__fill" style={{ width: `${(z.entropy_places / maxEnt) * 100}%` }} />
                          </div>
                          <span className="mono" style={{ fontSize: 12 }}>{z.entropy_places}</span>
                        </div>
                      </td>
                      <td className="num mono">{z.radius_km}</td>
                      <td className="num mono">{Math.round((z.pct_home || 0) * 100)}%</td>
                      <td className="num mono">{z.active_days}</td>
                      <td className="num mono">{(z.users || 0).toLocaleString('fr-FR')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Panel>
          </>
        )}
      </div>
    </>
  );
}
